import {
  CompanyExperiment,
  SpecialUser,
  UserExperiment
} from '@blisspointmedia/bpm-types/dist/FeatureExperiments';
import { Header } from '../../Components/StickyTable';
import { ModalEditWidget } from '../../Components/ModalEditWidget';
import { GroupedDataRow } from './types';
import { useCanEditExperiments } from './useCanEditExperiments';
import { useGroupedExperimentTable } from './useGroupedExperimentTable';
import './ExperimentTable.scss';

interface ExperimentTableOptions<T extends UserExperiment | CompanyExperiment | SpecialUser> {
  headers: Header[];
  name: string;
  addButtonText: string;
  createNewRow: (groupedColumn: string, groupByColumn: string) => T;
  groupByColumn: keyof T;
  groupedColumn: keyof T;
  expectedKeys: (keyof T & string)[];
  jsonField: 'user_experiments' | 'company_experiments' | 'special_users';
  modalTitle?: string;
}

interface ExperimentTableProps<T extends UserExperiment | CompanyExperiment | SpecialUser> {
  options: ExperimentTableOptions<T>;
}

export const ExperimentTable = <T extends UserExperiment | CompanyExperiment | SpecialUser>({
  options
}: ExperimentTableProps<T>) => {
  const {
    headers,
    name,
    addButtonText,
    createNewRow,
    groupByColumn,
    groupedColumn,
    expectedKeys,
    jsonField,
    modalTitle
  } = options;

  const { initialTableData, selectorOptions, onSaveModal, loading } = useGroupedExperimentTable<
    T,
    typeof groupedColumn
  >(jsonField, expectedKeys, groupByColumn, groupedColumn, createNewRow);

  const canEdit = useCanEditExperiments();

  return (
    <div className='experiment-table-page-container'>
      <ModalEditWidget<GroupedDataRow<T, typeof groupedColumn>>
        name={name}
        className='experiment-table'
        headers={headers}
        initialTableData={initialTableData}
        onSaveModal={onSaveModal}
        selectorOptions={selectorOptions}
        addButtonText={addButtonText}
        readOnly={!canEdit}
        enableAdd={canEdit}
        modalTitle={modalTitle}
        isLoading={loading}
      />
    </div>
  );
};
